/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { MenuItem, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setPriceLoadDetailsChanged,
  updatePriceLoadDetailsTableCell,
} from '../../store/action';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';

const RequestDrugPriceLoadDetailsDrugCdComponent = React.memo((props) => {
  const dispatch = useDispatch();
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const [selectedValue, setSelectedValue] = useState(props.value || null);
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const checkedHandler = (e) => {
    const { colId } = props.column;
    const inputValue = e.target.value;
    props.node.setDataValue(colId, inputValue === '' ? null : inputValue);
    dispatch(setPriceLoadDetailsChanged(true));
    dispatch(
      updatePriceLoadDetailsTableCell(
        props.rowIndex,
        colId,
        inputValue === '' ? null : inputValue
      )
    );
    setSelectedValue(inputValue); // Update selected value
  };

  const priceLoadDetailsTableData = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceLoadDetailsTableData
  );

  const ref = React.useRef();
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default action of Enter key
      e.stopPropagation(); // Stop event propagation to prevent other listeners
    }
  };

  React.useEffect(() => {
    // const handleKeyDowns = (e) => {
    //   if (e.keyCode === 9 || e.keyCode === 39) {
    //     props.addRow(priceLoadDetailsTableData?.priceTableData);
    //   }
    // };
    // ref.current.parentElement.addEventListener('keydown', handleKeyDowns);
    // return () => {
    //   ref.current.parentElement.removeEventListener('keydown', handleKeyDowns);
    // };
  }, [props, priceLoadDetailsTableData]);

  return (
    <div ref={ref}>
      <TextField
        id={`textfield_${props.column.colId}_${props.rowIndex}`}
        className='frr-display-hidden-label'
        label={props.column.colId}
        data-testid={`textfield_${props.column.colId}_${props.rowIndex}`}
        fullWidth
        select
        placeholder=''
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{ disableUnderline: true }}
        inputProps={{
          id: `textfield_${props.column.colId}_${props.rowIndex}`,
        }}
        disabled={props.disabled || !isEnablebyRole || false}
        //value={!props.value ? -1 : props.value}
        value={selectedValue}
        onChange={checkedHandler}
        tabIndex={0}
        // onKeyDown={handleKeyDown}
      >
        <MenuItem key='' value='-1' className='frr-dropdown-blank-item' />
        {props.dropdownData.length > 0 &&
          props.dropdownData.map((item, index) => {
            return (
              <MenuItem key={index} value={item.value}>
                {item.label}
              </MenuItem>
            );
          })}
      </TextField>
      <select
        style={{
          position: 'absolute',
          visibility: 'hidden',
          pointerEvents: 'none',
        }}
        aria-hidden='true'
        tabIndex='-1'
        value={selectedValue}
        onChange={checkedHandler}
      >
        {props.dropdownData.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
});

export default RequestDrugPriceLoadDetailsDrugCdComponent;
